import { render, staticRenderFns } from "./empty-page.vue?vue&type=template&id=ec79d4fa&functional=true"
var script = {}
import style0 from "./empty-page.vue?vue&type=style&index=0&id=ec79d4fa&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports